import { LAYOUT } from "./type";

export const updateLayout = data => {
  return {
    type: LAYOUT.MAIN_HEADER,
    payload: data
  };
};
